import type { ConversationSource } from "../../types";
import { fmtPhoneDigits, fmtPhoneDisplay } from "../../format";

interface PhoneLinkProps {
  phone?: string | null;
  source?: ConversationSource | null;
}

/**
 * Renderiza telefone formatado. Link aponta pra wa.me se source=whatsapp,
 * senão pra tel: (default seguro). Sem digits, mostra raw.
 */
export function PhoneLink({ phone, source }: PhoneLinkProps) {
  if (!phone) return <>—</>;
  const digits = fmtPhoneDigits(phone);
  const display = fmtPhoneDisplay(phone);
  if (!digits) return <>{phone}</>;

  const sourceKey = (source || "whatsapp").toLowerCase();
  const href = sourceKey === "whatsapp"
    ? `https://wa.me/${digits}`
    : `tel:+${digits}`;
  const target = sourceKey === "whatsapp" ? "_blank" : undefined;
  const rel = sourceKey === "whatsapp" ? "noopener" : undefined;

  return (
    <a class="phone-link" href={href} target={target} rel={rel}>
      {display}
    </a>
  );
}
